"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var authentication_service_1 = require("../shared/service/authentication.service");
var Authenticator = /** @class */ (function () {
    function Authenticator(authenticationService, router) {
        this.authenticationService = authenticationService;
        this.router = router;
    }
    Authenticator.prototype.canActivate = function () {
        var user = this.authenticationService.getUserFromLocalStorage();
        if (user) {
            return true;
        }
        this.router.navigate(['/login']);
        return false;
    };
    Authenticator.ctorParameters = function () { return [{ type: authentication_service_1.AuthenticationService }, { type: router_1.Router }]; };
    return Authenticator;
}());
exports.Authenticator = Authenticator;
//# sourceMappingURL=authenticator.js.map


// WEBPACK FOOTER //
// authenticator.js